export const COURIERS_COD = {
  couriers: [
    "FLE",
    "FLEWP",
    "JNT",
    "THP",
    "CJLX",
    "SCG",
    "ECP",
    "NJV",
    "BEST",
    "TRUE",
    "EMST",
    "BEE",
    "EMSXP",
    "KRYQ",
    "KRYS",
    "DHL",
  ],
  condition: {
    default: {
      min: 100,
      max: 50000,
    },
    JNT: {
      min: 100,
      max: 10000,
    },
    MSE: {
      min: 100,
      max: 100000,
    },
    MSEC: {
      min: 100,
      max: 100000,
    },
    SPE: {
      min: 100,
      max: 100000,
    },
    SPEC: {
      min: 100,
      max: 100000,
    },
  },
};
